var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEntryOrExitAllowPopup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 26.0916L18 2C18 2 23 2 23 8.28478V19.8069H41C41.7635 19.8025 42.5121 20.0284 43.1565 20.4575C43.8008 20.8866 44.3136 21.5009 44.6338 22.227C44.954 22.953 45.068 23.7603 44.9622 24.5523C44.8563 25.3444 44.5352 26.0878 44.037 26.6939C44.693 27.0968 45.2249 27.6884 45.5694 28.3986C45.914 29.1087 46.0567 29.9074 45.9807 30.7C45.9046 31.4926 45.6131 32.2456 45.1405 32.8698C44.668 33.4939 44.0344 33.9629 43.315 34.221C43.6701 34.7702 43.895 35.4001 43.9712 36.0586C44.0475 36.7171 43.9727 37.3851 43.7533 38.0072C43.5338 38.6294 43.1759 39.1878 42.7093 39.6362C42.2426 40.0846 41.6807 40.4099 41.07 40.5854C41.504 41.0179 41.8041 41.5768 41.9316 42.1899C42.0591 42.803 42.008 43.442 41.7851 44.0244C41.5622 44.6068 41.1776 45.1057 40.6811 45.4568C40.1846 45.8078 39.599 45.9947 39 45.9934H23C18.4846 46.0951 14.0163 45.015 10 42.851",
    stroke: "#27AE60",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 21.9014H4C2.89543 21.9014 2 22.8393 2 23.9963V42.8506C2 44.0076 2.89543 44.9455 4 44.9455H8C9.10457 44.9455 10 44.0076 10 42.8506V23.9963C10 22.8393 9.10457 21.9014 8 21.9014Z",
    stroke: "#27AE60",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEntryOrExitAllowPopup);
export default __webpack_public_path__ + "static/media/icon_entryOrExitAllowPopup.1987b22a.svg";
export { ForwardRef as ReactComponent };